<div class="model-container">
  <div class="model-header p-1 px-4">
    <div class="d-flex justify-content-between align-items-center" *ngIf="detailsFormData">
      <div>
        <h1 class="mb-0 fw-bold fs-6">{{detailsFormData.itineraryName}}</h1>
      </div>

      <div class="d-flex">
        <ion-button class="filled-blue-btn" (click)="createQuoteForNewLead($event)" *ngIf="!leadId && itineraryStatus === RECORD_STATUS_VALUES.APPROVED">Create Quote</ion-button>
        <ion-button class="filled-blue-btn" (click)="sendItinerary($event)">Send</ion-button>
        <ion-button class="filled-blue-btn" *ngIf="!leadId && itineraryStatus === RECORD_STATUS_VALUES.PENDING" (click)="approveInventoryItinerary()">Approve</ion-button>
        <ion-button class="filled-blue-btn" *ngIf="!leadId" (click)="editInventoryItinerary()">Edit</ion-button>
        <ion-button *ngIf="leadId" class="filled-blue-btn" (click)="createQuote()">Create Quote</ion-button>
        <ion-button class="unfilled-gray-btn" (click)="closeModal()"><ion-icon name="close-outline"></ion-icon></ion-button>
      </div>
    </div>
  </div>

  <div class="model-content" #sendthishtmldivtag>
    <div class="itinerary-main-container" style="padding: 10px 20px;" *ngIf="detailsFormData">
      <div>
        <h3 class="section-title">{{detailsFormData.itineraryName}}</h3>
      </div>
      <div>
        <div class="itinerary-details-container">
          <div>
            <p class="title">Itinerary Name</p>
            <p class="value">{{detailsFormData.itineraryName}}</p>
          </div>
          <div class="w-50">
            <p class="title">Destinations</p>
            <p class="value"><span *ngFor="let dest of detailsFormData.destination; index as i">{{dest.location}}<span *ngIf="i+1 !== detailsFormData.destination.length"> | </span></span></p>
            <!-- <p class="value">{{detailsFormData.destination.join(', ')}}</p> -->
          </div>
          <div>
            <p class="title">No Of Days</p>
            <p class="value">{{detailsFormData.totalDays + 1}} Days</p>
          </div>
        </div>
      </div>

      <div *ngIf="detailsFormData.note">
        <p class="sub-title mb-0">Details Note</p>
        <p class="text" [innerHTML]="formatNewLineText(detailsFormData.note)"></p>
      </div>

      <!-- Route craft -->

      <ng-container *ngIf="routeCraftFormData">
        <div>
          <h3 class=" red-bg-title">Day Wise Plan</h3>
        </div>
        <div>
          <ng-container *ngFor="let route of routeCraftFormData.data">
            <div class="">
              <p class="sub-title">{{route.day}}</p>
            </div>
            <div  *ngIf="route.activities">
              <p class="text" [innerHTML]="formatNewLineText(route.activities)"></p>
            </div>
          </ng-container>
          
        </div>

        <div *ngIf="routeCraftFormData.note">
          <p class="sub-title mb-0">Sightseeing Note</p>
          <p class="text" [innerHTML]="formatNewLineText(routeCraftFormData.note)"></p>
        </div>
      </ng-container>
      

      <!-- Inclusion exclusion -->
       <ng-container *ngIf="inclusionsAndExclusionsFormData">
        <div>
          <h3 class="red-bg-title">Inclusions & Exclusions</h3>
        </div>
        <div>

          <div class="">
            <p class="sub-title">Includes</p>
          </div>
          
          <div>
            <ul class="list">
              <ng-container *ngFor="let include of inclusionsAndExclusionsFormData.include">
                <li *ngIf="include.checked">{{include.name}}</li>
              </ng-container>
            </ul>
          </div>

          <div *ngIf="inclusionsAndExclusionsFormData.inclusionNote">
            <p class="sub-title mb-0">Inclusion Note</p>
            <p class="text" [innerHTML]="formatNewLineText(inclusionsAndExclusionsFormData.inclusionNote)"></p>
          </div>
        
          
  
          <div class="">
            <p class="sub-title">Excludes</p>
          </div>
          <div>
            <ul class="list">
              <ng-container *ngFor="let exclude of inclusionsAndExclusionsFormData.exclude">
                <li *ngIf="exclude.checked">{{exclude.name}}</li>
              </ng-container>
            </ul>
          </div> 
          
          <div *ngIf="inclusionsAndExclusionsFormData.exclusionNote">
            <p class="sub-title mb-0">Exclusion Note</p>
            <p class="text" [innerHTML]="formatNewLineText(inclusionsAndExclusionsFormData.exclusionNote)"></p>
          </div>

        </div>

        <div *ngIf="inclusionsAndExclusionsFormData.note">
          <p class="sub-title mb-0">I&E Note</p>
          <p class="text" [innerHTML]="formatNewLineText(inclusionsAndExclusionsFormData.note)"></p>
        </div>
       </ng-container>
      
      
      <!-- Terms and conditions -->

      <ng-container *ngIf="termsAndConditionsFormData">
        <div>
          <h3 class="red-bg-title">Terms & Conditions</h3>
        </div>
        <div>
          <div>
            <ul class="list">
              <ng-container *ngFor="let item of termsAndConditionsFormData.termsAndConditions">
                <li *ngIf="item.checked">{{item.name}}</li>
              </ng-container>
            </ul>
          </div>      
        </div>  

        <div *ngIf="termsAndConditionsFormData.note">
          <p class="sub-title mb-0">T&C Note</p>
          <p class="text" [innerHTML]="formatNewLineText(termsAndConditionsFormData.note)"></p>
        </div>
      </ng-container>
      

      <!-- Cancellation policy -->

      <ng-container *ngIf="cancellationPolicyFormData">
        <div>
          <h3 class="red-bg-title">Cancellation Policies</h3>
        </div>
        <div>
          <div>
            <ul class="list">
              <ng-container *ngFor="let item of cancellationPolicyFormData.cancellationPolicys">
                <li *ngIf="item.checked">{{item.name}}</li>
              </ng-container>
            </ul>
          </div>      
        </div>  

        <div *ngIf="cancellationPolicyFormData.note">
          <p class="sub-title mb-0">Cancellation Note</p>
          <p class="text" [innerHTML]="formatNewLineText(cancellationPolicyFormData.note)"></p>
        </div>
      </ng-container>

      <!-- Imporatant Information -->

      <ng-container *ngIf="importantInformationFormData">
        <div>
          <h3 class="red-bg-title">Important Information</h3>
        </div>
        <div>
          <div>
            <ul class="list">
              <ng-container *ngFor="let item of importantInformationFormData.importantInformation">
                <li *ngIf="item.checked">{{item.name}}</li>
              </ng-container>
            </ul>
          </div>      
        </div>  

        <div *ngIf="importantInformationFormData.note">
          <p class="sub-title mb-0">Important Note</p>
          <p class="text" [innerHTML]="formatNewLineText(importantInformationFormData.note)"></p>
        </div>
      </ng-container>

      <!-- Notes -->

      <ng-container *ngIf="notesFormData?.note">
        <div>
          <h3 class="red-bg-title">Notes</h3>
        </div>
        <div>
          <div>
            <p class="text" [innerHTML]="formatNewLineText(notesFormData.note)"></p>
          </div>      
        </div>
      </ng-container>

      


    </div>
  </div>
</div>